import type { MissionListItem } from '../lib/missionCategories'

import { CardRewards, CardTile } from '@/shared/ui/Card'

import { SubmissionStatusTag } from './SubmissionStatusTag'

interface MissionListItemCardProps {
  item: MissionListItem
  onClick?: () => void
}

// Renders the normalized MissionListItem shape (Mission or PassObjective
// alike) through one card — see design.md Decision 9. Sibling to
// MissionCard.tsx, which stays Mission-specific for MissionsFeed's own use.
export function MissionListItemCard({ item, onClick }: MissionListItemCardProps) {
  // Bloqueio corta o onClick na origem, não só no visual: sem handler, não há
  // modal para abrir nem conclusão para disparar.
  const handleClick = item.locked ? undefined : onClick

  return (
    <CardTile
      onClick={handleClick}
      className={[
        handleClick ? 'cursor-pointer' : undefined,
        item.locked ? 'opacity-60 grayscale' : undefined
      ]
        .filter(Boolean)
        .join(' ')}
      aria-disabled={item.locked || undefined}
    >
      {item.imageUrl ? (
        <img
          src={item.imageUrl}
          className="size-14 lg:size-16 rounded-xl shrink-0"
          alt=""
        />
      ) : null}
      <div className="flex flex-col gap-1 grow min-w-0">
        <div className="flex items-center gap-1 min-w-0">
          {item.locked ? (
            <span aria-hidden className="shrink-0">
              🔒
            </span>
          ) : null}
          <span className="text-[#00298F] font-semibold font-sans text-sm line-clamp-2">
            {item.title}
          </span>
          <SubmissionStatusTag status={item.submissionStatus} />
        </div>
        {item.locked && item.lockHint ? (
          <span className="text-gray-500 font-sans text-xs line-clamp-2">
            {item.lockHint}
          </span>
        ) : null}
        {/* Motivo da recusa: o aluno precisa saber o que corrigir antes de
            reenviar, não só que a missão voltou. */}
        {!item.locked && item.submissionFeedback ? (
          <span className="text-[#B3261E] font-sans text-xs line-clamp-2 break-words">
            {item.submissionFeedback}
          </span>
        ) : null}
        {item.showProgress && (
          <div className="w-full rounded-sm bg-[#50507C] h-[16px] text-center text-white text-xs font-sans relative">
            <div
              className="absolute top-0 left-0 w-full h-full bg-primary rounded-sm"
              style={{ width: `${item.progress.percentage}%` }}
            />
            <span className="absolute top-0 left-0 w-full h-full flex items-center justify-center">
              {item.progress.current}/{item.progress.total}
            </span>
          </div>
        )}
      </div>
      {!item.locked ? (
        <div className="min-w-[76px] flex justify-end shrink-0">
          <CardRewards
            coinReward={item.coinReward}
            pointReward={item.pointReward}
            completed={item.completed}
            claimed={item.claimed}
          />
        </div>
      ) : null}
    </CardTile>
  )
}
